export default [
  'additional_personal_debt',
  'amex',
  'student_loan',
  'debt_already_counted',
  'zero_balance_tradelines',
  'rental_property_mortgage_debt',
  // 'living_expense',
  'irs_payment_plan',
  'additional_spousal_debt',
  'annual_personal_debt_payments' // Derived category
]